import { JSONHelpers } from './JSONHelpers';

export const CUSTOMER_GROUP_SEPARATOR = ';';

const getEffectiveDate = (stringifyJson?: string): string | undefined => {
    return JSONHelpers.getField(stringifyJson, 'effectiveDate', 'string');
};

const getCustomerGroups = (stringifyJson?: string): string | undefined => {
    const groups = JSONHelpers.getField(stringifyJson, 'customerGroups', 'stringArray');

    return groups ? groups.join(CUSTOMER_GROUP_SEPARATOR) : undefined;
};

export const ShopTheFutureHelpers = {
    getEffectiveDate,
    getCustomerGroups,
};
